"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/core/styles");
const useStyles = (0, _styles.makeStyles)({
  popup: {
    zIndex: 2
  }
});
var _default = exports.default = useStyles;